var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidMinusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM16.3024 12.8873C16.7925 12.8873 17.1897 12.4901 17.1897 12C17.1897 11.51 16.7925 11.1127 16.3024 11.1127H7.69761C7.20756 11.1127 6.81029 11.51 6.81029 12C6.81029 12.4901 7.20756 12.8873 7.69761 12.8873H16.3024Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidMinusCircle);
export default __webpack_public_path__ + "static/media/solid-minus-circle.b7649f12082183095366632686a29084.svg";
export { ForwardRef as ReactComponent };